import React from 'react';

// Background image at low opacity — watermark style
export const BgImage = ({ image }) => image ? (
  <img src={image} alt="" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', opacity: 0.22, pointerEvents: 'none' }} />
) : null;

const TopRibbon = ({ color }) => (
  <div style={{ position: 'absolute', top: 0, right: 24, width: 40, zIndex: 4, pointerEvents: 'none' }}>
    <div style={{ display: 'flex', height: 88 }}>
      <div style={{ flex: 1, background: '#c9a84c' }} />
      <div style={{ flex: 1, background: color }} />
      <div style={{ flex: 1, background: '#ffd700' }} />
      <div style={{ flex: 1, background: color }} />
      <div style={{ flex: 1, background: '#c9a84c' }} />
    </div>
    <svg width="40" height="18" viewBox="0 0 40 18"><polygon points="0,0 40,0 20,18" fill="#c9a84c"/></svg>
  </div>
);

const Trophy = ({ color }) => (
  <svg width="50" height="54" viewBox="0 0 50 54" style={{ position: 'absolute', top: 14, right: 74, zIndex: 5, pointerEvents: 'none' }}>
    <path d="M15 5 L35 5 L32 21 A10 10 0 0 1 18 21 Z" fill="#ffd700" stroke={color} strokeWidth="1.2"/>
    <path d="M15 7 Q7 7 7 15 Q7 22 15 22" fill="none" stroke="#ffd700" strokeWidth="3.5" strokeLinecap="round"/>
    <path d="M35 7 Q43 7 43 15 Q43 22 35 22" fill="none" stroke="#ffd700" strokeWidth="3.5" strokeLinecap="round"/>
    <rect x="22" y="21" width="6" height="8" fill="#daa520"/>
    <rect x="14" y="29" width="22" height="4" rx="2" fill={color}/>
    <rect x="17" y="33" width="16" height="3" rx="1" fill="#ffd700"/>
    <polygon points="25,9 26.8,14.5 32,14.5 27.8,17.8 29.5,23 25,20 20.5,23 22.2,17.8 18,14.5 23.2,14.5" fill={color} opacity="0.9"/>
  </svg>
);

const BottomSwooshLeft = ({ color }) => (
  <svg style={{ position: 'absolute', bottom: 0, left: 0, zIndex: 1, pointerEvents: 'none' }} width="210" height="115" viewBox="0 0 210 115" fill="none">
    <path d="M0 115 L0 52 C28 18 92 24 132 56 C160 80 164 108 144 115 Z" fill="#ffd700" opacity="0.45"/>
    <path d="M0 115 L0 64 C20 42 72 48 106 72 C128 88 132 112 118 115 Z" fill="#c9a84c" opacity="0.85"/>
    <path d="M0 115 L0 78 C14 66 50 70 76 88 C94 100 97 114 86 115 Z" fill={color} opacity="0.9"/>
  </svg>
);

const BottomSwooshRight = ({ color }) => (
  <svg style={{ position: 'absolute', bottom: 0, right: 0, zIndex: 1, pointerEvents: 'none' }} width="210" height="115" viewBox="0 0 210 115" fill="none">
    <path d="M210 115 L210 52 C182 18 118 24 78 56 C50 80 46 108 66 115 Z" fill="#ffd700" opacity="0.45"/>
    <path d="M210 115 L210 64 C190 42 138 48 104 72 C82 88 78 112 92 115 Z" fill="#c9a84c" opacity="0.85"/>
    <path d="M210 115 L210 78 C196 66 160 70 134 88 C116 100 113 114 124 115 Z" fill={color} opacity="0.9"/>
  </svg>
);

const BottomSeal = () => (
  <div style={{ position: 'absolute', bottom: 20, left: '50%', transform: 'translateX(-50%)', zIndex: 5, pointerEvents: 'none' }}>
    <svg width="54" height="64" viewBox="0 0 54 64">
      <polygon points="18,52 27,42 27,64 22,60 18,64" fill="#8B0000"/>
      <polygon points="36,52 27,42 27,64 32,60 36,64" fill="#700000"/>
      <circle cx="28" cy="28" r="21" fill="rgba(0,0,0,0.18)"/>
      <circle cx="27" cy="27" r="21" fill="#1a1a1a"/>
      <circle cx="27" cy="27" r="18" fill="#242424"/>
      <circle cx="27" cy="27" r="18" fill="none" stroke="#ffd700" strokeWidth="2"/>
      <circle cx="27" cy="27" r="14" fill="none" stroke="#c9a84c" strokeWidth="1"/>
      <polygon points="27,14 29.5,21 37,21 31,26 33.5,33 27,28.5 20.5,33 23,26 17,21 24.5,21" fill="#ffd700"/>
    </svg>
  </div>
);

const Ornament = ({ flip }) => (
  <svg width="44" height="14" viewBox="0 0 44 14" fill="none" style={{ transform: flip ? 'scaleX(-1)' : 'none' }}>
    <path d="M2 7 Q11 1 22 7 Q33 13 42 7" stroke="#c9a84c" strokeWidth="1.5" fill="none"/>
    <circle cx="2" cy="7" r="2" fill="#c9a84c"/>
    <circle cx="22" cy="7" r="1.5" fill="#ffd700" opacity="0.8"/>
    <circle cx="42" cy="7" r="1.5" fill="#c9a84c" opacity="0.6"/>
  </svg>
);

// Shared white-background certificate layout
export const CertLayout = ({ data, accent, accentDark, title, titleEn, children }) => (
  <div style={{ width: 842, height: 595, background: '#fffef8', position: 'relative', overflow: 'hidden', fontFamily: "'Segoe UI',Arial,sans-serif", color: '#2c2c4a', display: 'flex', flexDirection: 'column' }}>
    <BgImage image={data.image} />
    <div style={{ position: 'absolute', top: 0, left: 0, width: 0, height: 0, borderTop: `115px solid ${accent}`, borderRight: '115px solid transparent', zIndex: 3, pointerEvents: 'none' }} />
    <div style={{ position: 'absolute', top: 0, left: 0, width: 0, height: 0, borderTop: `76px solid ${accentDark}`, borderRight: '76px solid transparent', zIndex: 3, pointerEvents: 'none' }} />
    <TopRibbon color={accent} />
    <Trophy color={accent} />
    <BottomSwooshLeft color={accent} />
    <BottomSwooshRight color={accent} />
    <BottomSeal />
    <div style={{ position: 'absolute', top: 8, right: 8, bottom: 8, left: 8, border: '3px solid #c9a84c', borderRadius: 3, pointerEvents: 'none', zIndex: 4 }} />
    <div style={{ position: 'absolute', top: 13, right: 13, bottom: 13, left: 13, border: '1px solid rgba(201,168,76,0.5)', borderRadius: 2, pointerEvents: 'none', zIndex: 4 }} />
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', paddingTop: 22, gap: 14, position: 'relative', zIndex: 5 }}>
      <img src="/Logo.jpeg" alt="Logo" style={{ width: 60, height: 60, borderRadius: '50%', border: `2px solid ${accent}` }} />
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 26, fontWeight: 900, letterSpacing: 3, color: accentDark, textTransform: 'uppercase' }}>KARIGAR FOUNDATION</div>
        <div style={{ fontSize: 10, color: '#c9a84c', letterSpacing: 1.5, textTransform: 'uppercase' }}>कला, संस्कृति और कौशल का सम्मान</div>
      </div>
    </div>
    <div style={{ display: 'flex', alignItems: 'center', gap: 6, margin: '5px 55px', position: 'relative', zIndex: 5 }}>
      <div style={{ flex: 1, height: 1.5, background: '#c9a84c' }} />
      <div style={{ width: 6, height: 6, borderRadius: '50%', background: accent }} />
      <div style={{ width: 6, height: 6, borderRadius: '50%', background: '#c9a84c' }} />
      <div style={{ width: 6, height: 6, borderRadius: '50%', background: accent }} />
      <div style={{ flex: 1, height: 1.5, background: '#c9a84c' }} />
    </div>
    <div style={{ textAlign: 'center', position: 'relative', zIndex: 5 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 10 }}>
        <Ornament />
        <div style={{ fontSize: 32, fontWeight: 900, color: '#c9a84c', fontFamily: 'serif', letterSpacing: 4 }}>{title}</div>
        <Ornament flip />
      </div>
      <div style={{ fontSize: 10, color: accentDark, letterSpacing: 3, fontWeight: 700, marginTop: 1, textTransform: 'uppercase' }}>{titleEn}</div>
      <div style={{ display: 'inline-block', background: accent, color: '#fff', fontSize: 10, fontWeight: 700, padding: '3px 22px', borderRadius: 20, marginTop: 6 }}>यह प्रमाणित किया जाता है कि</div>
    </div>
    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign: 'center', margin: '0 90px', position: 'relative', zIndex: 5 }}>
      {children}
    </div>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', margin: '0 65px 32px', position: 'relative', zIndex: 5, fontSize: 11 }}>
      <div>
        <div style={{ color: '#666' }}>प्रमाण पत्र संख्या: <strong style={{ color: accent }}>{data.certNo}</strong></div>
        <div style={{ color: '#666', marginTop: 4 }}>दिनांक: {data.issueDate}</div>
        <div style={{ color: '#999', marginTop: 4 }}>स्थान: {data.place || '________________'}</div>
      </div>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontFamily: "'Dancing Script', cursive", fontSize: 28, color: accentDark, lineHeight: 1.1, marginBottom: 2 }}>Rohit Kumar</div>
        <div style={{ width: 150, borderTop: `1px solid ${accent}`, paddingTop: 4, color: '#555' }}>अध्यक्ष / संस्थापक</div>
        <div style={{ color: accentDark, fontWeight: 700 }}>कारीगर फाउंडेशन</div>
      </div>
    </div>
  </div>
);

export const AppointmentCert = ({ data }) => (
  <CertLayout data={data} accent="#1a3a6b" accentDark="#0d2651" title="नियुक्ति प्रमाण पत्र" titleEn="APPOINTMENT CERTIFICATE">
    <div style={{ fontSize: 22, fontWeight: 700, color: '#1a3a6b', borderBottom: '2px solid #c9a84c', display: 'inline-block', minWidth: 280, paddingBottom: 3, marginBottom: 8 }}>{data.name}</div>
    <div style={{ fontSize: 14, color: '#2c2c4a', lineHeight: 1.9 }}>को कारीगर फाउंडेशन में <strong style={{ color: '#1a3a6b' }}>({data.role || 'पद'})</strong> के पद पर नियुक्त किया जाता है।</div>
    <div style={{ fontSize: 12, color: '#666', marginTop: 6 }}>हमें पूर्ण विश्वास है कि आप संस्था के उद्देश्यों एवं सिद्धांतों के अनुरूप अपनी जिम्मेदारियों का निष्ठापूर्वक निर्वहन करेंगे।</div>
  </CertLayout>
);

export const RegistrationCert = ({ data }) => (
  <CertLayout data={data} accent="#1a5c38" accentDark="#0d3320" title="पंजीकरण प्रमाण पत्र" titleEn="REGISTRATION CERTIFICATE">
    <div style={{ fontSize: 22, fontWeight: 700, color: '#1a5c38', borderBottom: '2px solid #c9a84c', display: 'inline-block', minWidth: 280, paddingBottom: 3, marginBottom: 8 }}>{data.name}</div>
    <div style={{ fontSize: 14, color: '#2c2c4a', lineHeight: 2 }}>को कारीगर फाउंडेशन का <strong style={{ color: '#1a5c38', fontSize: 17 }}>पंजीकृत सदस्य</strong> के रूप में पंजीकृत किया गया है।</div>
    <div style={{ fontSize: 12, color: '#666', marginTop: 4 }}>सदस्यता संख्या: <strong style={{ color: '#b8860b' }}>{data.certNo}</strong></div>
  </CertLayout>
);

export const ExperienceCert = ({ data }) => (
  <CertLayout data={data} accent="#7b1a1a" accentDark="#3d0c0c" title="अनुभव प्रमाण पत्र" titleEn="EXPERIENCE CERTIFICATE">
    <div style={{ fontSize: 14, color: '#888', fontStyle: 'italic', marginBottom: 2 }}>श्री / सुश्री</div>
    <div style={{ fontSize: 22, fontWeight: 700, color: '#7b1a1a', borderBottom: '2px solid #c9a84c', display: 'inline-block', minWidth: 280, paddingBottom: 3, marginBottom: 6 }}>{data.name}</div>
    <div style={{ fontSize: 13, color: '#2c2c4a', lineHeight: 1.9 }}>ने कारीगर फाउंडेशन में दिनांक <strong style={{ color: '#7b1a1a' }}>{data.fromDate || '___'}</strong> से <strong style={{ color: '#7b1a1a' }}>{data.toDate || '___'}</strong> तक <strong style={{ color: '#7b1a1a' }}>{data.role || 'पद'}</strong> पर कार्य किया।</div>
  </CertLayout>
);

export const CulturalCert = ({ data }) => (
  <CertLayout data={data} accent="#4a1a5c" accentDark="#2d0050" title="सांस्कृतिक प्रमाण पत्र" titleEn="CULTURAL CERTIFICATE">
    <div style={{ fontSize: 22, fontWeight: 700, color: '#4a1a5c', borderBottom: '2px solid #c9a84c', display: 'inline-block', minWidth: 280, paddingBottom: 3, marginBottom: 8 }}>{data.name}</div>
    <div style={{ fontSize: 14, color: '#2c2c4a', lineHeight: 1.9 }}>ने कारीगर फाउंडेशन द्वारा आयोजित <strong style={{ color: '#4a1a5c' }}>{data.eventName || 'कार्यक्रम का नाम'}</strong> में उत्कृष्ट प्रदर्शन कर सामाजिक एवं सांस्कृतिक उत्थान में सहयोग दिया है।</div>
  </CertLayout>
);

export const CERT_COMPONENTS = {
  appointment: AppointmentCert,
  registration: RegistrationCert,
  experience: ExperienceCert,
  cultural: CulturalCert,
};
